var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',{staticClass:"ui-snackbar-container",attrs:{"name":"toast-fade","tag":"div"}},_vm._l((_vm.snackMessages),function(snackMessage){return _c('woot-snackbar',{key:snackMessage.key,attrs:{"message":snackMessage.message,"action":snackMessage.action}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }